import React from 'react';
import { shape, string } from 'prop-types';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import Tooltip from '@material-ui/core/Tooltip';

import classes from './RulesTable.module.css';

const NameCell = ({ row, ...props }) => {
    return (
        <Table.Cell {...props}>
            <Tooltip title={<span className={classes.tooltip}>{row.name}</span>} placement="top">
                <span>{row.name}</span>
            </Tooltip>
        </Table.Cell>
    );
};

NameCell.defaultProps = {
    row: {
        name: ''
    }
};

NameCell.propTypes = {
    row: shape({
        name: string
    })
};

export default NameCell;
